(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 10000;
  var DRAWER_ID  = 'fcd-drawer';
  var OVERLAY_ID = 'fcd-overlay';

  // Products that should have fixed quantity (qty buttons hidden, always show as 1).
  // Add product handles here.
  var FIXED_QTY_HANDLES = [
    'manukind-sample-diapers-3pack',
    'manukind-sample-pack-for-shopify-collective-only',
    'manukind-sample-kit'
  ];

  function isFixedQtyItem(item) {
    return item && item.handle && FIXED_QTY_HANDLES.indexOf(item.handle) !== -1;
  }

  var cart       = null;
  var escListenerAdded = false;
  var bodyDelegationAttached = false;

  window._fcdCart = null;

  // ============================================================
  // GLOBAL CART MUTATION QUEUE
  // ============================================================
  // Every cart-modifying API call (qty change, plan change, etc.)
  // goes through this queue. Operations run strictly one at a time
  // in FIFO order. Eliminates races caused by concurrent API calls.
  // ============================================================
  var queueRunning = false;
  var queue = [];
  var idleCallbacks = [];

  function setQueueIndicator(busy) {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    if (busy) {
      drawer.classList.add('fcd-queue-busy');
    } else {
      drawer.classList.remove('fcd-queue-busy');
    }
  }

  function processQueue() {
    if (queueRunning) return;
    var next = queue.shift();
    if (!next) {
      setQueueIndicator(false);
      var cbs = idleCallbacks.slice();
      idleCallbacks.length = 0;
      cbs.forEach(function (cb) { try { cb(); } catch (_) {} });
      return;
    }
    queueRunning = true;
    setQueueIndicator(true);
    Promise.resolve()
      .then(next.fn)
      .then(function (result) {
        next.resolve(result);
      })
      .catch(function (err) {
        next.reject(err);
      })
      .then(function () {
        queueRunning = false;
        processQueue();
      });
  }

  window._fcdEnqueueCartMutation = function (fn) {
    return new Promise(function (resolve, reject) {
      queue.push({ fn: fn, resolve: resolve, reject: reject });
      processQueue();
    });
  };

  window._fcdQueueBusy = function () {
    return queueRunning || queue.length > 0;
  };

  window._fcdOnQueueIdle = function (cb) {
    if (!window._fcdQueueBusy()) { cb(); return; }
    idleCallbacks.push(cb);
  };

  function getLatestCart() {
    if (window._fcdCart) {
      cart = window._fcdCart;
      return cart;
    }
    return cart;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchCart(cb) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        window._fcdCart = data;
        if (cb) cb(data);
        return data;
      })
      .catch(function (e) { console.warn('[FCD]', e); });
  }

  // ============================================================
  // QTY CHANGE FLOW (uses queue)
  // ============================================================
  var pendingDesiredQty = {};
  var queuedQtyKeys = {};

  function updateCart(key, quantity) {
    pendingDesiredQty[key] = quantity;

    // Optimistic render
    var sourceCart = getLatestCart();
    if (sourceCart) {
      var optimisticCart = JSON.parse(JSON.stringify(sourceCart));
      Object.keys(pendingDesiredQty).forEach(function (k) {
        var q = pendingDesiredQty[k];
        if (q === 0) {
          optimisticCart.items = optimisticCart.items.filter(function (i) { return i.key !== k; });
        } else {
          optimisticCart.items = optimisticCart.items.map(function (i) {
            if (i.key === k) {
              i.quantity = q;
              i.final_line_price = i.final_price * q;
            }
            return i;
          });
        }
      });
      optimisticCart.total_price = optimisticCart.items.reduce(function (sum, i) { return sum + i.final_line_price; }, 0);
      optimisticCart.item_count  = optimisticCart.items.reduce(function (sum, i) { return sum + i.quantity; }, 0);
      renderCart(optimisticCart, false);
    }

    if (queuedQtyKeys[key]) return;
    queuedQtyKeys[key] = true;

    window._fcdEnqueueCartMutation(function () {
      var lineKey = key;
      var desired = pendingDesiredQty[lineKey];
      delete pendingDesiredQty[lineKey];
      delete queuedQtyKeys[lineKey];

      if (desired === undefined) return Promise.resolve();

      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: desired })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart change failed: ' + r.status);
          return r.json();
        })
        .then(function (data) {
          cart = data;
          window._fcdCart = data;
          renderCart(data, false);
          if (desired === 0 && data.items.length === 0) {
            setTimeout(closeDrawer, 300);
          }
        })
        .catch(function (e) {
          console.warn('[FCD]', e);
          return fetchCart(function (fresh) {
            if (fresh) renderCart(fresh, false);
          });
        });
    });
  }

  function unlockScroll() {
    var savedY = window._fcdScrollY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.body.style.touchAction = '';
    if (savedY !== undefined) {
      window.scrollTo(0, savedY);
      window._fcdScrollY = undefined;
    }
    document.body.classList.remove('overflow-hidden','no-scroll','scroll-lock','is-locked','rebuy-cart-visible');
  }

  function lockScroll() {
    window._fcdScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + window._fcdScrollY + 'px';
    document.body.style.width = '100%';
  }

  function buildShippingBar(totalPrice) {
    var percent   = Math.min(100, Math.round((totalPrice / FREE_SHIPPING_THRESHOLD) * 100));
    var remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
    var message   = totalPrice >= FREE_SHIPPING_THRESHOLD
      ? '<strong>🎉 You\'ve unlocked FREE SHIPPING!</strong>'
      : 'You are <strong>' + formatMoney(remaining) + '</strong> away from FREE SHIPPING!';
    return '<div class="fcd-shipping-bar">' +
      '<div class="fcd-shipping-bar__track"><div class="fcd-shipping-bar__fill" style="width:' + percent + '%"></div></div>' +
      '<p class="fcd-shipping-bar__text">' + message + '</p>' +
    '</div>';
  }

  function buildItem(item) {
    var img     = item.image || '';
    var price   = formatMoney(item.final_line_price);
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var subText = item.selling_plan_allocation
      ? '<p class="fcd-item__subscription">♻ ' + item.selling_plan_allocation.selling_plan.name + '</p>'
      : '';
    var fixedQty = isFixedQtyItem(item);
    var qtyMarkup = fixedQty
      ? '<div class="fcd-item__qty fcd-item__qty--fixed">' +
          '<span class="fcd-item__qty-static">Qty: ' + item.quantity + '</span>' +
        '</div>'
      : '<div class="fcd-item__qty">' +
          '<button class="fcd-item__qty-btn fcd-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
          '<span class="fcd-item__qty-num" aria-live="polite">' + item.quantity + '</span>' +
          '<button class="fcd-item__qty-btn fcd-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '</div>';
    return '<div class="fcd-item" data-key="' + item.key + '" data-variant-id="' + item.variant_id + '">' +
      '<a href="/products/' + item.handle + '" class="fcd-item__img-wrap">' +
        '<img class="fcd-item__img" src="' + img + '" alt="' + item.product_title + '" loading="lazy">' +
      '</a>' +
      '<div class="fcd-item__info">' +
        '<a class="fcd-item__title" href="/products/' + item.handle + '">' + item.product_title + '</a>' +
        (variant ? '<p class="fcd-item__variant">' + variant + '</p>' : '') +
        subText +
        '<div class="fcd-item__price-row">' +
          qtyMarkup +
          '<span class="fcd-item__price">' + price + '</span>' +
        '</div>' +
        '<button class="fcd-item__remove fcd-qty-btn" data-key="' + item.key + '" data-qty="0" aria-label="Remove item">Remove</button>' +
      '</div>' +
    '</div>';
  }

  function buildEmpty() {
    return '<div class="fcd-empty"><p>Your cart is empty</p><a href="/collections/all">Shop Now</a></div>';
  }

  var lastCartSignature = '';

  function setText(el, value) {
    if (!el) return;
    if (el.textContent !== value) el.textContent = value;
  }

  function reconcileSubBadge(itemEl, item) {
    if (!itemEl) return;
    var existing = itemEl.querySelector('.fcd-item__subscription');
    if (item.selling_plan_allocation) {
      var planName = item.selling_plan_allocation.selling_plan.name;
      var newText = '♻ ' + planName;
      if (existing) {
        if (existing.textContent !== newText) existing.textContent = newText;
        return;
      }
      var infoEl = itemEl.querySelector('.fcd-item__info');
      if (!infoEl) return;
      var badge = document.createElement('p');
      badge.className = 'fcd-item__subscription';
      badge.textContent = newText;
      var variantEl = infoEl.querySelector('.fcd-item__variant');
      var titleEl   = infoEl.querySelector('.fcd-item__title');
      var priceRow  = infoEl.querySelector('.fcd-item__price-row');
      if (variantEl && variantEl.parentNode === infoEl) {
        variantEl.insertAdjacentElement('afterend', badge);
      } else if (titleEl && titleEl.parentNode === infoEl) {
        titleEl.insertAdjacentElement('afterend', badge);
      } else if (priceRow && priceRow.parentNode === infoEl) {
        infoEl.insertBefore(badge, priceRow);
      } else {
        infoEl.appendChild(badge);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function renderCart(data, allowSubInject) {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer || !data) return;

    var bodyForScroll = drawer.querySelector('.fcd-body');
    var savedScroll = bodyForScroll ? bodyForScroll.scrollTop : 0;

    cart = data;
    window._fcdCart = data;

    var allItems = data.items || [];
    var isEmpty  = allItems.length === 0;

    var fillEl = drawer.querySelector('.fcd-shipping-bar__fill');
    var textEl = drawer.querySelector('.fcd-shipping-bar__text');
    if (fillEl && textEl) {
      var percent   = Math.min(100, Math.round((data.total_price / FREE_SHIPPING_THRESHOLD) * 100));
      var remaining = FREE_SHIPPING_THRESHOLD - data.total_price;
      var newWidth  = percent + '%';
      if (fillEl.style.width !== newWidth) fillEl.style.width = newWidth;
      var newMsg = data.total_price >= FREE_SHIPPING_THRESHOLD
        ? '<strong>🎉 You\'ve unlocked FREE SHIPPING!</strong>'
        : 'You are <strong>' + formatMoney(remaining) + '</strong> away from FREE SHIPPING!';
      if (textEl.innerHTML !== newMsg) textEl.innerHTML = newMsg;
    }

    var itemsWrap = drawer.querySelector('.fcd-items-wrap');
    var emptyWrap = drawer.querySelector('.fcd-empty-wrap');

    if (itemsWrap) {
      var newKeys = allItems.map(function (i) {
        return i.key + ':' + i.quantity + ':' + i.final_line_price;
      }).join(',');
      var oldKeys = itemsWrap.dataset.keys || '';

      if (isEmpty) {
        if (oldKeys !== '' || itemsWrap.children.length > 0) {
          itemsWrap.innerHTML = '';
          itemsWrap.dataset.keys = '';
        }
        if (emptyWrap && !emptyWrap.firstChild) {
          emptyWrap.innerHTML = buildEmpty();
        }
      } else {
        if (emptyWrap && emptyWrap.firstChild) {
          emptyWrap.innerHTML = '';
        }

        if (newKeys === oldKeys) {
          allItems.forEach(function (item) {
            var itemEl = itemsWrap.querySelector('[data-key="' + item.key + '"]');
            reconcileSubBadge(itemEl, item);
          });
        } else {
          var oldItemKeys = oldKeys.split(',').map(function (s) { return s.split(':')[0]; }).filter(Boolean);
          var newItemKeys = allItems.map(function (i) { return i.key; });

          var sameItems =
            oldKeys !== '' &&
            oldItemKeys.length === newItemKeys.length &&
            newItemKeys.every(function (k) { return oldItemKeys.indexOf(k) !== -1; });

          if (sameItems) {
            allItems.forEach(function (item) {
              var itemEl = itemsWrap.querySelector('[data-key="' + item.key + '"]');
              if (!itemEl) return;
              var priceEl = itemEl.querySelector('.fcd-item__price');
              var qtyEl   = itemEl.querySelector('.fcd-item__qty-num');
              var staticQtyEl = itemEl.querySelector('.fcd-item__qty-static');
              var btns    = itemEl.querySelectorAll('.fcd-qty-btn');
              setText(priceEl, formatMoney(item.final_line_price));
              if (qtyEl) setText(qtyEl, String(item.quantity));
              if (staticQtyEl) setText(staticQtyEl, 'Qty: ' + item.quantity);
              if (btns[0]) {
                var dec = String(item.quantity - 1);
                if (btns[0].dataset.qty !== dec) btns[0].dataset.qty = dec;
              }
              if (btns[1]) {
                var inc = String(item.quantity + 1);
                if (btns[1].dataset.qty !== inc) btns[1].dataset.qty = inc;
              }
              reconcileSubBadge(itemEl, item);
            });
          } else {
            itemsWrap.innerHTML = allItems.map(buildItem).join('');
            if (typeof window.fcdInjectSubscriptions === 'function') {
              window.fcdInjectSubscriptions(true);
            }
          }
        }
        itemsWrap.dataset.keys = newKeys;
      }
    }

    var footer = drawer.querySelector('.fcd-footer');
    if (footer) {
      var subtotalEl = footer.querySelector('.fcd-subtotal__price');
      var checkoutEl = footer.querySelector('.fcd-checkout-btn');
      setText(subtotalEl, formatMoney(data.total_price));
      setText(checkoutEl, 'CHECKOUT • ' + formatMoney(data.total_price));
    }

    if (bodyForScroll && savedScroll > 0 && bodyForScroll.scrollTop !== savedScroll) {
      bodyForScroll.scrollTop = savedScroll;
    }

    killRebuy();

    updateCartCount(allItems.reduce(function(sum, i) { return sum + i.quantity; }, 0));

    var uniqueHandles = {};
    allItems.forEach(function (i) { uniqueHandles[i.handle] = true; });
    var currentSig = Object.keys(uniqueHandles).sort().join(',');
    if (currentSig !== lastCartSignature) {
      lastCartSignature = currentSig;
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('fcd:cart:handles:changed'));
      }, 150);
    }
  }

  window.fcdRenderCart = function (cartData) {
    if (cartData) {
      cart = cartData;
      window._fcdCart = cartData;
      renderCart(cartData, false);
    } else {
      fetchCart(function (data) { renderCart(data, false); });
    }
  };

  function attachBodyDelegation(body) {
    if (bodyDelegationAttached) return;
    body.addEventListener('click', function (e) {
      var btn = e.target.closest('.fcd-qty-btn');
      if (!btn || !body.contains(btn)) return;
      if (!btn.closest('.fcd-items-wrap')) return;
      var key = btn.dataset.key;
      var qty = parseInt(btn.dataset.qty, 10);
      if (!key || isNaN(qty)) return;
      updateCart(key, qty);
    });
    bodyDelegationAttached = true;
  }

  function updateCartCount(count) {
    document.querySelectorAll('.header__cart-count, .cart-count-bubble span:first-child, [data-cart-count]').forEach(function (el) {
      var s = String(count);
      if (el.textContent !== s) el.textContent = s;
    });
  }

  function killRebuy() {
    var rebuySelectors = [
      '.rebuy-cart__overlay',
      '.rebuy-cart__background',
      '.rebuy-cart__cover',
      '.rebuy-cart__flyout',
      '#rebuy-cart',
      '.rebuy-cart__backdrop',
      '.rebuy-modal__overlay',
      '.rebuy-cart-overlay',
      '[class*="rebuy"][class*="overlay"]',
      '[class*="rebuy"][class*="backdrop"]',
      // Manukind theme native cart-drawer web component
      'cart-drawer',
      'cart-drawer.drawer',
      '.drawer.animate'
    ];
    rebuySelectors.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          // Don't kill our own drawer
          if (el.id === DRAWER_ID || el.id === OVERLAY_ID) return;
          if (el.closest && el.closest('#' + DRAWER_ID)) return;
          var hidden = 'display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;';
          if (el.style.cssText !== hidden) {
            el.style.cssText = hidden;
          }
          // Also remove the active class so it can't re-open
          if (el.classList && el.classList.contains('active')) {
            el.classList.remove('active');
          }
        });
      } catch (_) {}
    });
    if (document.body.classList.contains('rebuy-cart-visible')) {
      document.body.classList.remove('rebuy-cart-visible');
    }
    ['rebuy-cart-open','rebuy-modal-open','cart-open','drawer-open','overflow-hidden'].forEach(function (cls) {
      if (document.body.classList.contains(cls)) {
        document.body.classList.remove(cls);
      }
    });
  }

  function injectQueueIndicatorStyles() {
    if (document.getElementById('fcd-queue-indicator-styles')) return;
    var style = document.createElement('style');
    style.id = 'fcd-queue-indicator-styles';
    style.textContent = [
      '#fcd-drawer.fcd-queue-busy .fcd-qty-btn { opacity: 0.55; pointer-events: none; transition: opacity 0.15s ease; }',
      '#fcd-drawer.fcd-queue-busy .fcd-item__remove { opacity: 0.55; pointer-events: none; }',
      '#fcd-drawer.fcd-queue-busy .csub-select { opacity: 0.65; pointer-events: none; }',
      '#fcd-drawer.fcd-queue-busy .csub-upgrade-btn { opacity: 0.65; pointer-events: none; }',
      '#fcd-drawer.fcd-queue-busy { cursor: progress; }',
    ].join('\n');
    document.head.appendChild(style);
  }

  function createDrawer() {
    if (document.getElementById(DRAWER_ID)) return;

    injectQueueIndicatorStyles();

    var drawer = document.createElement('div');
    drawer.id = DRAWER_ID;
    drawer.className = 'fcd-drawer';
    drawer.innerHTML =
      '<div class="fcd-header">' +
        '<p class="fcd-header__title">Your Cart</p>' +
        '<div class="fcd-header__actions">' +
          '<a href="/account/login" class="fcd-login-btn">Login</a>' +
          '<button class="fcd-close-btn" id="fcd-close" aria-label="Close cart">✕</button>' +
        '</div>' +
      '</div>' +
      buildShippingBar(0) +
      '<div class="fcd-body">' +
        '<div class="fcd-empty-wrap"></div>' +
        '<div class="fcd-items-wrap fcd-items"></div>' +
        '<div class="fcd-extras"></div>' +
      '</div>' +
      '<div class="fcd-footer">' +
        '<div class="fcd-subtotal"><span class="fcd-subtotal__label">Subtotal</span><span class="fcd-subtotal__price">$0.00</span></div>' +
        '<a href="/checkout" class="fcd-checkout-btn">CHECKOUT</a>' +
      '</div>';

    document.body.appendChild(drawer);
    document.getElementById('fcd-close').addEventListener('click', closeDrawer);

    var body = drawer.querySelector('.fcd-body');
    if (body) attachBodyDelegation(body);

    if (!escListenerAdded) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
      escListenerAdded = true;
    }
  }

  function openDrawer(cartData) {
    if (!window._fcdUserOpenedCart) {
      if (cartData) { cart = cartData; window._fcdCart = cartData; }
      return;
    }

    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) {
      createDrawer();
      drawer = document.getElementById(DRAWER_ID);
    }

    if (cartData) {
      cart = cartData;
      window._fcdCart = cartData;
      renderCart(cartData, true);
    } else {
      var latest = getLatestCart();
      if (latest) renderCart(latest, true);
    }

    drawer.classList.add('is-open');
    lockScroll();
    killRebuy();

    if (!cartData) {
      fetchCart(function (fresh) {
        var freshPrice = fresh.total_price;
        var freshCount = fresh.item_count;
        var cartPrice  = cart ? cart.total_price : -1;
        var cartCount  = cart ? cart.item_count  : -1;
        if (freshPrice !== cartPrice || freshCount !== cartCount) {
          renderCart(fresh, false);
        }
      });
    }
  }

  function closeDrawer() {
    var drawer = document.getElementById(DRAWER_ID);
    if (drawer) drawer.classList.remove('is-open');
    unlockScroll();
    killRebuy();
  }

  function isCartTrigger(el) {
    var cartLink = el.closest('a[href="/cart"]');
    if (cartLink && cartLink.closest('header,.header,.site-header,.header__wrapper,.header__icons')) return true;
    return !!el.closest(
      '[data-drawer-trigger="drawer-cart"],' +
      '[data-open-drawer="drawer-cart"],' +
      '.js-drawer-open-cart,' +
      '[data-cart-toggle],' +
      '.cart-icon-bubble,' +
      '[data-testid="cart-icon-bubble"]'
    );
  }

  function hijackCartTriggers() {
    document.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      if (e.target.closest('a[href="/checkout"],.fcd-checkout-btn')) return;
      if (e.target.closest('#' + DRAWER_ID)) return;
      if (isCartTrigger(e.target)) {
        window._fcdUserOpenedCart = true;
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      }
    }, true);

    // Click-outside fallback: capture target identity at MOUSEDOWN (before
    // any handler can re-render the DOM and detach the click target).
    // The click handler only fires close if mousedown was OUTSIDE the drawer.
    var mouseDownInsideDrawer = false;
    document.addEventListener('mousedown', function (e) {
      if (!e.isTrusted) return;
      var drawer = document.getElementById(DRAWER_ID);
      if (!drawer || !drawer.classList.contains('is-open')) {
        mouseDownInsideDrawer = false;
        return;
      }
      mouseDownInsideDrawer = !!(e.target.closest && e.target.closest('#' + DRAWER_ID));
    }, true);

    document.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      var drawer = document.getElementById(DRAWER_ID);
      if (!drawer || !drawer.classList.contains('is-open')) return;
      // mousedown was inside the drawer — this is an internal click, ignore
      // even if the click target has been detached by a rerender.
      if (mouseDownInsideDrawer) {
        mouseDownInsideDrawer = false;
        return;
      }
      // Mousedown was outside drawer. Still safety-check current target:
      if (e.target.closest && e.target.closest('#' + DRAWER_ID)) return;
      if (e.target.closest && e.target.closest('a[href="/checkout"],.fcd-checkout-btn')) return;
      if (isCartTrigger(e.target)) return;
      closeDrawer();
    }, false);
  }

  // ============================================================
  // SUBSCRIPTION-INTENT DETECTION (CLICK-TRACKER)
  // ============================================================
  var lastSubscribeClick = 0;
  var SUBSCRIPTION_INTENT_WINDOW_MS = 8000;

  function isSubscribeClickTarget(el) {
    if (!el || !el.closest) return false;
    var subscribeRe = /\bsubscri(be|ption)\b|\brecur(ring)?\b/i;
    var oneTimeRe = /\bone[-\s]?time\b/i;

    var control = el.closest(
      'label,button,[role="tab"],[role="radio"],[data-purchase-type],' +
      '.purchase-option,.product-purchase-option,[data-toggle-purchase],' +
      'input[type="radio"]'
    );
    if (!control) return false;

    var classStr = (control.className && typeof control.className === 'string')
      ? control.className.toLowerCase() : '';
    if (/one[-_]?time/.test(classStr)) return false;
    var idStr = (control.id || '').toLowerCase();
    if (/one[-_]?time/.test(idStr)) return false;
    var purchaseTypeAttr = (control.getAttribute && control.getAttribute('data-purchase-type') || '').toLowerCase();
    if (/one[-_]?time|onetime|otp/.test(purchaseTypeAttr)) return false;

    var text = (control.textContent || '').trim();
    if (!text && control.tagName === 'INPUT') {
      var lbl = control.id ? document.querySelector('label[for="' + control.id + '"]') : null;
      if (lbl) text = (lbl.textContent || '').trim();
    }

    if (control.tagName === 'INPUT' && !text) {
      var enclosingLabel = control.closest('label');
      if (enclosingLabel) text = (enclosingLabel.textContent || '').trim();
    }

    if (!text) return false;

    if (oneTimeRe.test(text)) return false;
    if (subscribeRe.test(text)) return true;

    if (control.tagName === 'INPUT') {
      var name = (control.name || '').toLowerCase();
      var value = (control.value || '').toLowerCase();
      if (/onetime|one[-_]?time|one|otp/i.test(value)) return false;
      if (/subscri|recur/i.test(value) && /\bsell|subscri|purchase|plan|frequency/i.test(name)) {
        return true;
      }
      if (/subscri|recur/i.test(idStr)) return true;
    }

    return false;
  }

  function detectSubscriptionFromDOM() {
    var subscribeRe = /\bsubscri(be|ption)\b|\brecur(ring)?\b/i;
    var oneTimeRe   = /\bone[-\s]?time\b/i;

    var radios = document.querySelectorAll(
      'input[type="radio"]:checked, [role="radio"][aria-checked="true"]'
    );

    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];

      var name  = (r.name  || '').toLowerCase();
      var value = (r.value || '').toLowerCase();
      var id    = (r.id    || '').toLowerCase();
      var pType = ((r.getAttribute && r.getAttribute('data-purchase-type')) || '').toLowerCase();

      var classStr = '';
      if (r.className) {
        classStr = (typeof r.className === 'string')
          ? r.className.toLowerCase()
          : (r.className.baseVal || '').toLowerCase();
      }

      var label = '';
      if (r.id) {
        var lbl = document.querySelector('label[for="' + r.id + '"]');
        if (lbl) label = (lbl.textContent || '').trim();
      }
      if (!label && r.closest) {
        var enclosing = r.closest('label');
        if (enclosing) label = (enclosing.textContent || '').trim();
      }
      if (!label && r.closest) {
        var optBlock = r.closest('.purchase-option,.product-purchase-option,[data-purchase-type]');
        if (optBlock) label = (optBlock.textContent || '').trim();
      }

      var combined = (label + ' ' + value + ' ' + id + ' ' + name + ' ' + classStr + ' ' + pType);

      if (oneTimeRe.test(combined))                           return false;
      if (/onetime|one[-_]?time|\botp\b/.test(combined))      return false;
      if (subscribeRe.test(combined))                         return true;
    }

    return null;
  }

  function detectExplicitSubscriptionIntent() {
    var dom = detectSubscriptionFromDOM();
    if (dom === true)  return true;
    if (dom === false) return false;
    return (Date.now() - lastSubscribeClick) < SUBSCRIPTION_INTENT_WINDOW_MS;
  }

  function watchVariantChanges() {
    var lastVariant = '';
    function readVariant() {
      try {
        var url = new URL(window.location.href);
        return url.searchParams.get('variant') || '';
      } catch (_) {
        return '';
      }
    }
    lastVariant = readVariant();

    function checkVariant() {
      var current = readVariant();
      if (current !== lastVariant) {
        lastVariant = current;
        lastSubscribeClick = 0;
      }
    }

    setInterval(checkVariant, 250);
    window.addEventListener('popstate', checkVariant);
    window.addEventListener('hashchange', checkVariant);

    ['pushState', 'replaceState'].forEach(function (m) {
      var orig = history[m];
      if (typeof orig !== 'function') return;
      history[m] = function () {
        var ret = orig.apply(this, arguments);
        try { checkVariant(); } catch (_) {}
        return ret;
      };
    });
  }

  function trackUserGestures() {
    ['click', 'touchend'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        window._fcdLastUserGesture = Date.now();
        if (e.isTrusted && e.target && isSubscribeClickTarget(e.target)) {
          lastSubscribeClick = Date.now();
        }
      }, true);
    });
  }

  function stripSellingPlanFromBody(options) {
    if (!options || !options.body) return options;

    var body = options.body;
    var ct = '';
    if (options.headers) {
      if (typeof options.headers.get === 'function') {
        ct = options.headers.get('content-type') || '';
      } else {
        var headerKeys = Object.keys(options.headers);
        for (var i = 0; i < headerKeys.length; i++) {
          if (headerKeys[i].toLowerCase() === 'content-type') {
            ct = options.headers[headerKeys[i]] || '';
            break;
          }
        }
      }
    }

    if (typeof body === 'string') {
      try {
        var parsed = JSON.parse(body);
        var modified = false;
        if (parsed && typeof parsed === 'object') {
          if (Array.isArray(parsed.items)) {
            parsed.items.forEach(function (it) {
              if (it && (it.selling_plan !== undefined || (it.properties && it.properties._selling_plan_id !== undefined))) {
                delete it.selling_plan;
                if (it.properties) delete it.properties._selling_plan_id;
                modified = true;
              }
            });
          }
          if (parsed.selling_plan !== undefined) { delete parsed.selling_plan; modified = true; }
          if (parsed.properties && parsed.properties._selling_plan_id !== undefined) {
            delete parsed.properties._selling_plan_id;
            modified = true;
          }
          if (modified) {
            options.body = JSON.stringify(parsed);
            return options;
          }
        }
      } catch (e) {
        if (ct.indexOf('application/x-www-form-urlencoded') !== -1 || body.indexOf('=') !== -1) {
          try {
            var params = new URLSearchParams(body);
            if (params.has('selling_plan') || params.has('properties[_selling_plan_id]')) {
              params.delete('selling_plan');
              params.delete('properties[_selling_plan_id]');
              options.body = params.toString();
            }
          } catch (e2) {}
        }
      }
    } else if (body instanceof FormData) {
      if (body.has('selling_plan') || body.has('properties[_selling_plan_id]')) {
        body.delete('selling_plan');
        body.delete('properties[_selling_plan_id]');
      }
    } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      body.delete('selling_plan');
      body.delete('properties[_selling_plan_id]');
    }

    return options;
  }

  function interceptAddToCart() {
    var originalFetch = window.fetch;
    window.fetch = function (url, options) {
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      var method = (options && options.method && options.method.toUpperCase()) || 'GET';
      var isAdd = urlStr.indexOf('/cart/add') !== -1 && method === 'POST';

      var hadSubscriptionIntent = isAdd ? detectExplicitSubscriptionIntent() : false;

      if (isAdd && options && !hadSubscriptionIntent) {
        try { options = stripSellingPlanFromBody(options); }
        catch (err) { console.warn('[FCD] Failed to strip selling_plan:', err); }
      }

      var result = originalFetch.call(this, url, options);

      if (isAdd) {
        result.then(function (response) {
          if (!response || !response.ok) return;
          var clone;
          try { clone = response.clone(); } catch (_) { return; }
          clone.json().then(function (addResponse) {
            if (!hadSubscriptionIntent) {
              var addedLines = [];
              if (addResponse) {
                if (Array.isArray(addResponse.items)) {
                  addedLines = addResponse.items;
                } else if (addResponse.key) {
                  addedLines = [addResponse];
                }
              }
              var subLinesToFix = addedLines.filter(function (line) {
                return line && line.key && line.selling_plan_allocation;
              });
              if (subLinesToFix.length > 0) {
                subLinesToFix.forEach(function (line) {
                  if (typeof window._fcdEnqueueCartMutation === 'function') {
                    window._fcdEnqueueCartMutation(function () {
                      return fetch('/cart/change.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({
                          id: line.key,
                          selling_plan: '',
                          properties: {}
                        })
                      })
                      .then(function (r) { return r.ok ? r.json() : null; })
                      .then(function (data) {
                        if (data && data.items) {
                          window._fcdCart = data;
                        }
                      })
                      .catch(function () {});
                    });
                  } else {
                    fetch('/cart/change.js', {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: JSON.stringify({
                        id: line.key,
                        selling_plan: '',
                        properties: {}
                      })
                    }).catch(function () {});
                  }
                });
              }
            }

            // Force fixed-qty products back to qty 1 after add
            var addedLinesAll = [];
            if (addResponse) {
              if (Array.isArray(addResponse.items)) {
                addedLinesAll = addResponse.items;
              } else if (addResponse.key) {
                addedLinesAll = [addResponse];
              }
            }
            var fixedQtyLinesToFix = addedLinesAll.filter(function (line) {
              return line && line.key && isFixedQtyItem(line) && line.quantity > 1;
            });
            if (fixedQtyLinesToFix.length > 0) {
              fixedQtyLinesToFix.forEach(function (line) {
                if (typeof window._fcdEnqueueCartMutation === 'function') {
                  window._fcdEnqueueCartMutation(function () {
                    return fetch('/cart/change.js', {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: JSON.stringify({ id: line.key, quantity: 1 })
                    })
                    .then(function (r) { return r.ok ? r.json() : null; })
                    .then(function (data) {
                      if (data && data.items) {
                        window._fcdCart = data;
                      }
                    })
                    .catch(function () {});
                  });
                } else {
                  fetch('/cart/change.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: line.key, quantity: 1 })
                  }).catch(function () {});
                }
              });
            }

            var onCartOrCheckout = /\/cart(\/|$|\?)|\/checkout/.test(location.pathname);
            var suppressed = window._fcdSuppressOpenAfterAdd === true;
            if (!onCartOrCheckout && !suppressed) {
              window._fcdUserOpenedCart = true;
              window._fcdOnQueueIdle(function () {
                fetchCart(function (fullCart) {
                  openDrawer(fullCart);
                });
              });
            } else {
              fetchCart(null);
            }
          }).catch(function () {});
        }).catch(function () {});
      }

      return result;
    };

    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this._fcdMethod = (method || '').toUpperCase();
        this._fcdUrl = url || '';
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function (body) {
        var isAdd = this._fcdUrl && this._fcdUrl.indexOf('/cart/add') !== -1 && this._fcdMethod === 'POST';
        if (isAdd && !detectExplicitSubscriptionIntent() && body) {
          try {
            var fakeOpts = { body: body, headers: {} };
            fakeOpts = stripSellingPlanFromBody(fakeOpts);
            body = fakeOpts.body;
          } catch (err) {}
        }
        return origSend.call(this, body);
      };
    }
  }

  function suppressThemeCart() {
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes') {
          var t = m.target;
          if (!t || !t.tagName) return;
          var tag = t.tagName.toLowerCase();
          // Manukind: <cart-drawer class="drawer animate active">
          if (tag === 'cart-drawer') {
            if (t.classList.contains('active')) {
              t.classList.remove('active');
              t.classList.remove('animate');
            }
            killRebuy();
          }
          // Other themes: <mini-cart open>
          if (m.attributeName === 'open' && tag === 'mini-cart') {
            t.removeAttribute('open');
          }
          // Other themes: cart toggle aria-expanded=true
          if (m.attributeName === 'aria-expanded') {
            if (t.classList && t.classList.contains('header__cart-toggle') &&
                t.getAttribute('aria-expanded') === 'true') {
              t.setAttribute('aria-expanded', 'false');
            }
          }
        }
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            var tag = n.tagName && n.tagName.toLowerCase();
            if (tag === 'mini-cart' && n.hasAttribute('open')) {
              n.removeAttribute('open');
            }
            if (tag === 'cart-drawer') {
              if (n.classList.contains('active')) {
                n.classList.remove('active');
              }
            }
            // Also check descendants
            if (n.querySelector) {
              var mc = n.querySelector('mini-cart[open]');
              if (mc) mc.removeAttribute('open');
              var cd = n.querySelector('cart-drawer.active');
              if (cd) cd.classList.remove('active');
            }
          });
        }
      });
    });
    obs.observe(document.body, {
      childList: true, subtree: true,
      attributes: true,
      attributeFilter: ['open','class','aria-expanded']
    });

    // Initial sweep
    document.querySelectorAll('cart-drawer.active').forEach(function (el) {
      el.classList.remove('active');
    });
    document.querySelectorAll('mini-cart[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
  }

  function maybeStartRebuyKiller() {
    var detected = !!document.querySelector(
      '.rebuy-cart__overlay,.rebuy-cart__flyout,[data-rebuy-component],#rebuy-cart,cart-drawer,.drawer.animate'
    );
    if (detected) {
      setInterval(killRebuy, 1000);
      return;
    }
    var watchUntil = Date.now() + 15000;
    var detectObs = new MutationObserver(function () {
      if (document.querySelector('.rebuy-cart__overlay,.rebuy-cart__flyout,[data-rebuy-component],#rebuy-cart,cart-drawer,.drawer.animate')) {
        detectObs.disconnect();
        setInterval(killRebuy, 1000);
        return;
      }
      if (Date.now() > watchUntil) detectObs.disconnect();
    });
    detectObs.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    createDrawer();
    hijackCartTriggers();
    trackUserGestures();
    watchVariantChanges();
    interceptAddToCart();
    suppressThemeCart();
    fetchCart(null);
    maybeStartRebuyKiller();
    document.addEventListener('cart:refresh', function () {
      if (window._fcdUserOpenedCart) openDrawer();
    });
    document.addEventListener('theme:cart:change', function (e) {
      var updated = e.detail && e.detail.cart;
      if (updated) { renderCart(updated, false); }
      else { fetchCart(function (data) { renderCart(data, false); }); }
    });
    unlockScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();